import jwt from 'jsonwebtoken';
import { ServerAuth } from '@555platform/author.js';
import { handleHttpErrors, RequestFailureError, UnknownResponseError } from '../graphql/errors';
import config from '../config';

const tokens = {};
const getToken = (appDomain) => {
  if (tokens[appDomain] !== undefined) {
    const decoded = jwt.decode(tokens[appDomain]);
    let curDate = new Date();
    curDate = Math.floor(curDate.getTime() / 1000);
    if (decoded.exp > curDate) {
      return tokens[appDomain];
    }
  }
  const serverAuth = ServerAuth({
    domain: config[appDomain].domain,
    clientID: config[appDomain].appKey,
    clientSecret: config[appDomain].appSecret,
    redirectURI: config[appDomain].redirectURI,
    authServer: config[appDomain].authServer,
  });
  return serverAuth
    .getServerToken()
    .then((response) => {
      tokens[appDomain] = response.access_token;
      return tokens[appDomain];
    })
    .catch((error) => {
      if (error.response) {
        return handleHttpErrors(error);
      }
      if (error.request) {
        throw new RequestFailureError();
      } else {
        throw new UnknownResponseError();
      }
    });
};

export default getToken;
